import React from 'react'
import {Box} from 'grommet'
import CreateUserForm from '../../../components/createUserForm'
import { API,Auth } from 'aws-amplify';
import { withRouter } from 'react-router-dom';
import { NavigationSnackBar } from '../../../components/utils/shared/shared';
class CreateUser extends React.Component {

    state = {
        load: false,
        value: {name: '', password: '', email: '', group:'Lab'},
        lab: {organisation: {}, name: 'Select Lab...', primary_contact_person: '',primary_contact_email: '', primary_contact_phone: '',address:{AddressLineOne: '', AddressLineTwo: '',AddressLineThree: '',City: '',PostCode: '',Country: ''}}
    }

    handleLabChange = (event) => {
        this.setState({lab: event});
      };

      handleChange = (event) => {
          this.setState({value: event});
        };
  
    handleSubmit = () => {
      this.setState({load: true})
      const login = {username: this.state.value.username, password: this.state.value.password, email: this.state.value.email, group: this.state.value.group, lab: this.state.lab}
      Auth.currentSession().then(session => {
        API
        .post("LabShip", "/auth/sign_up",
        { headers: { 
          Authorization: session.idToken.jwtToken,
        }, 
        body:login})
        .then(user => {
          this.setState({error: false, load:false})
          this.props.history.push({
            pathname: '/admin/users/all',
            state: { user: user},
          })
       }).catch(err => this.setState({errorMessage: err, error: true}))
      })
      }
    
    render(){
        const {load,value, lab} = this.state;
        return ( 
          <Box>
            <NavigationSnackBar title={'Create User'} user={this.props.user} pages={[{name: 'Dashboard', link: '/dashboard'},{name: 'Users', link: '/users/all'}]}  />
            <Box direction='row' justify="center" flex="grow">
                <CreateUserForm handleSubmit={this.handleSubmit} handleChange={this.handleChange} handleLabChange={this.handleLabChange} value={value} load={load} lab={lab}/>
            </Box>
            </Box>
          )
    }
}

export default withRouter(CreateUser)
